import { NCALayerStatuses, NCALayerModes } from "@/config/consts";
import { BaseModule } from "@/store/base.module";
import { translate } from "@/utils";
import { Catch } from "@/utils/decorators";
import { AxiosError } from "axios";
import { EDSConfig, SignKey } from "~/eds.type";
import { Api } from "./api.service";

export class SignService {
  public static async signXML(
    storageType: string,
    content: string,
    options: EDSConfig,
  ): Promise<MessageValue<string | boolean>> {
    return new Promise(resolve => {
      const webSocket = new WebSocket("wss://127.0.0.1:13579/");
      webSocket.onopen = function() {
        const args = {
          data: content,
          locale: localStorage.getItem("locale"),
          format: "xml",
          allowedStorages: [storageType],
          signingParams: {
            decode: true,
            encapsulate: true,
            digested: false,
            tsaProfile: null as any,
          },
          signerParams: {
            extKeyUsageOids: [
              options.signKey === "AUTHENTICATION"
                ? "1.3.6.1.5.5.7.3.2"
                : "1.3.6.1.5.5.7.3.4",
            ] as any,
            iin: "",
            bin: "",
            serialNumber: "",
            chain: null as any,
          },
        };

        const payload = {
          module: "kz.gov.pki.knca.basics",
          method: "sign", // options.signMethod,
          args,
        };

        webSocket.send(JSON.stringify(payload));
      };

      webSocket.onclose = function(event) {
        //console.log("event", event);
        if (!event.wasClean) {
          BaseModule.showMessage({
            message: translate("eds.error") as string,
            color: "error",
          });
          resolve({
            result: false,
            message: NCALayerStatuses.NOT_CONNECTED,
          });
        }
      };

      webSocket.onmessage = function(event) {
        const result = JSON.parse(event.data);
        if (result && result["status"]) {
          if (result["body"]["result"]) {
            const res = result["body"]["result"];
            resolve({ result: res[0] });
          } else
            resolve({
              result: false,
              message: "action.canceled",
            });

          webSocket.close();
        }
      };
    });
  }

  @Catch((e: AxiosError) => {
    return {
      result: false,
      message: e.response?.data.message,
    };
  })
  public static async validateEDS(
    data: string,
    action: SignKey,
    bin?: string,
  ): Promise<{ result: Dictionary; message?: ApiMessageObject }> {
    const result = await Api.post("eds/validate", {
      signedData: data,
      action,
      bin,
    });
    return {
      result: result.data,
    };
  }
}
